/**
 * <s-share-buttons> — product sharing row (see snippets/share-buttons.liquid).
 * WhatsApp and Pinterest are plain links (work without JS). The Instagram button
 * ([data-share-native]) opens the device share sheet (Instagram Stories/Direct, WhatsApp, …)
 * where the Web Share API exists; elsewhere it copies the link and shows a short
 * confirmation in [data-share-status] (polite live region).
 *
 * Attributes: data-url, data-title.
 */
class SShareButtons extends HTMLElement {
  #ac;
  #timer;

  connectedCallback() {
    this.#ac = new AbortController();
    this.querySelector('[data-share-native]')?.addEventListener('click', () => this.#share(), {
      signal: this.#ac.signal,
    });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return; // shopper closed the sheet
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      this.#confirm();
    } catch (error) {
      window.prompt('', url); // last resort: let the shopper copy it manually
    }
  }

  #confirm() {
    const status = this.querySelector('[data-share-status]');
    if (!status) return;
    status.textContent = status.dataset.message || '';
    status.hidden = false;
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => {
      status.hidden = true;
      status.textContent = '';
    }, 2500);
  }
}

if (!customElements.get('s-share-buttons')) {
  customElements.define('s-share-buttons', SShareButtons);
}
